import EditablePropsType, { ContributorType } from '../../../types/composer';

export type AnswersSchemaProps = { question: string; answer: string };

export const answerSchema = {
  type: EditablePropsType.Object,
  name: 'answer',
  properties: {
    question: {
      type: EditablePropsType.Text,
      name: 'question',
      label: 'Question',
    },
    answer: {
      type: EditablePropsType.RichText,
      name: 'answer',
      label: 'Answer',
    },
  },
};

export const answersSchema = {
  label: 'Q&A',
  name: 'answers',
  type: EditablePropsType.Array,
  items: answerSchema,
};

export const citationSchema = {
  type: EditablePropsType.Object,
  name: 'citation',
  properties: {
    type: {
      type: EditablePropsType.Select,
      name: 'type',
      label: 'Type',
      selectOptions: {
        options: Object.values(ContributorType).map((val) => ({
          label: val,
          value: val,
        })),
      },
    },
    name: {
      // TODO: in legacy this is an autocomplete of team members
      type: EditablePropsType.Text,
      name: 'name',
      label: 'Name',
    },
  },
};

export const citationsSchema = {
  label: 'Citations',
  name: 'citations',
  type: EditablePropsType.Array,
  items: citationSchema,
};
